import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@gapartners/ui';

export interface ConfirmDiscardChangesDialogProps {
  open: boolean;
  onDiscard: () => void;
  onKeepEditing: () => void;
  /** Overrides the default "If you close now…" message. */
  message?: string;
  /** Overrides the default "Discard changes" button label. */
  discardLabel?: string;
}

export function ConfirmDiscardChangesDialog(
  props: ConfirmDiscardChangesDialogProps
) {
  const { open, onDiscard, onKeepEditing, message, discardLabel } = props;
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onKeepEditing} maxWidth="sm">
      <DialogTitle>
        <Typography variant="subtitle1" fontWeight={600}>
          {t('components.contactCenter.unsavedCaseChangesTitle')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {message ?? t('components.contactCenter.unsavedCaseChangesMessage')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onKeepEditing} color="inherit">
          {t('components.contactCenter.keepEditing')}
        </Button>
        <Button variant="contained" color="error" onClick={onDiscard}>
          {discardLabel ?? t('components.contactCenter.discardCaseChanges')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
